import {
  geStatusListApi,
  getUnderwriters,
  getWorkTypes,
  lockWorkItem,
  updateWorkItem,
} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as A from 'ApplicationEntry/ducks/AWDStatus';
import {push} from 'connected-react-router';
import {createSnackbar} from 'Core/ducks/snackbar';
import {AsyncResult, Loaded} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';

type LockWorkItemModel = {
  message: string;
  workInstance: {
    lockedTo: string;
  };
};

function* getWorkTypeList() {
  yield takeLatest(A.AWDStatusActionType.GET_WORK_TYPES, function*(action: ReturnType<typeof A.getWorkTypeList>) {
    const response: AsyncResult<{workTypes: string[]}> = yield call(getWorkTypes, action.payload.businessArea);
    if (E.isRight(response)) {
      yield put(A.changeWorkTypeList(new Loaded(response.right.workTypes)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(A.changeWorkTypeList(response.left));
    }
  });
}

function* getStatusList() {
  yield takeLatest(A.AWDStatusActionType.GET_STATUS, function*(action: ReturnType<typeof A.getStatusList>) {
    const response: AsyncResult<{statusTypes: string[]}> = yield call(
      geStatusListApi,
      action.payload.businessArea,
      action.payload.workType
    );
    if (E.isRight(response)) {
      yield put(A.changeStatusList(new Loaded(response.right.statusTypes)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(A.changeStatusList(response.left));
    }
  });
}

function* getUnderwriterList() {
  yield takeLatest(A.AWDStatusActionType.GET_UNDERWRITER, function*(action: ReturnType<typeof A.getUnderwriterList>) {
    const response: AsyncResult<{underwriters: [{underwriter: string}]}> = yield call(getUnderwriters);
    if (E.isRight(response)) {
      const result: string[] = response.right.underwriters.map(uw => uw.underwriter);
      yield put(A.changeUnderwriterList(new Loaded(result)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(A.changeUnderwriterList(response.left));
    }
  });
}

function* updateWork() {
  yield takeLatest(A.AWDStatusActionType.UPDATE_WORK, function*(action: ReturnType<typeof A.updateWork>) {
    const lockResponse: AsyncResult<LockWorkItemModel> = yield call(lockWorkItem, action.payload.work.awdKeyId);
    if (E.isRight(lockResponse)) {
      const status: number = yield call(updateWorkItem, action.payload.work);
      if (status === 204 || status === 200 || status === 201) {
        yield all([put(createSnackbar('AWD Save Successful')), put(push(ApplicationEntryRouteConstants.WorkQueue))]);
      } else {
        yield all([put(createSnackbar('AWD Save Failed')), put(push(ApplicationEntryRouteConstants.WorkQueue))]);
      }
    } else if (lockResponse.left.key === 'Unauthorized') {
      yield all([put(createSnackbar('AWD Save Failed')), put(push(ApplicationEntryRouteConstants.AWDLogin))]);
    } else {
      yield all([put(createSnackbar('AWD Save Failed')), put(push(ApplicationEntryRouteConstants.WorkQueue))]);
    }
  });
}

export default function*() {
  yield all([getWorkTypeList(), getStatusList(), getUnderwriterList(), updateWork()]);
}
